import store from "@/state/store";

export default [
  //login
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //forgot password
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      },
    },
  },
  //reset password
  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/create-password.vue"),
    meta: {
      title: "Reset Account Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      }
    },
  },
  //logout
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout.vue"),
    meta: {
      title: "Logout",
      beforeResolve(routeTo, routeFrom, next) {

        localStorage.removeItem("user");
        localStorage.removeItem("userid");
        localStorage.removeItem("jwt");

        next();
      },
    },
  },
  //default dashboard
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/default/index.vue"),
  },
  //client management - client
  {
    path: "/client",
    name: "client",
    meta: {
      title: "Client",
      authRequired: true,
    },
    component: () => import("../views/client/client.vue"),
  },
  //client management - site
  {
    path: "/client/site",
    name: "Site",
    meta: {
      title: "Site",
      authRequired: true,
    },
    component: () => import("../views/client/site.vue"),
  },
  //client management - site qr viewer
  {
    path: "/client/site-qr-viewer",
    name: "Site QR Code Viewer",
    meta: {
      title: "Site QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/site-qr-viewer.vue"),
  },
  //client management - block
  {
    path: "/client/block",
    name: "Block",
    meta: {
      title: "Block",
      authRequired: true,
    },
    component: () => import("../views/client/block.vue"),
  },
  //client management - area
  {
    path: "/client/area",
    name: "Area",
    meta: {
      title: "Area",
      authRequired: true,
    },
    component: () => import("../views/client/area.vue"),
  },
  //client management - location
  {
    path: "/client/location",
    name: "Location",
    meta: {
      title: "Location",
      authRequired: true,
    },
    component: () => import("../views/client/location.vue"),
  },
  //client management - location qr viewer
  {
    path: "/client/location-qr-viewer",
    name: "Room QR Code Viewer",
    meta: {
      title: "Room QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/location-qr-viewer.vue"),
  },
  //client management - location import & preview
  {
    path: "/client/location-import",
    name: "Room Import & Preview",
    meta: {
      title: "Room Import & Preview",
      authRequired: true,
    },
    component: () => import("../views/client/location-import.vue"),
  },
  //user management - role
  {
    path: "/user/access-rights-profile",
    name: "Access Rights Profile",
    meta: {
      title: "Access Rights Profile",
      authRequired: true,
    },
    component: () => import("../views/user/role.vue"),
  },
  //user management - job role
  {
    path: "/user/job-role",
    name: "Job Role",
    meta: {
      title: "Job Role",
      authRequired: true,
    },
    component: () => import("../views/user/job-role.vue"),
  },
  //user management - dormitory
  {
    path: "/user/dormitory",
    name: "Dormitory",
    meta: {
      title: "Dormitory",
      authRequired: true,
    },
    component: () => import("../views/user/dormitory.vue"),
  },
  //user management - team
  {
    path: "/user/team",
    name: "Team",
    meta: {
      title: "Team",
      authRequired: true,
    },
    component: () => import("../views/user/team.vue"),
  },
  //user management - department
  {
    path: "/user/department",
    name: "Department",
    meta: {
      title: "Department",
      authRequired: true,
    },
    component: () => import("../views/user/department.vue"),
  },
  //user management - user
  {
    path: "/user/employee",
    name: "User",
    meta: {
      title: "User",
      authRequired: true,
    },
    component: () => import("../views/user/employee.vue"),
  },
  //user management - employee payroll setting
  {
    path: "/user/employee-payroll-setting",
    name: "Employee Payroll Setting",
    meta: {
      title: "Employee Payroll Setting",
      authRequired: true,
    },
    component: () => import("../views/user/employee-payroll-setting.vue"),
  },

  //cost management - allowance / deduction
  {
    path: "/cost/allowance-deduction",
    name: "Allowance / Deduction",
    meta: {
      title: "Allowance / Deduction",
      authRequired: true,
    },
    component: () => import("../views/cost/allowance-deduction.vue"),
  },
  //cost management - attendance & rate report
  {
    path: "/cost/attendance-pay-rate-report",
    name: "Attendance & Rate Report",
    meta: {
      title: "Attendance & Rate Report",
      authRequired: true,
    },
    component: () => import("../views/cost/attendance-pay-rate-report.vue"),
  },

  //attedance management - attendance listing
  {
    path: "/attendance/listing",
    name: "Attendance",
    meta: {
      title: "Attendance",
      authRequired: true,
    },
    component: () => import("../views/attendance/listing.vue"),
  },
  //attedance management - summary report
  {
    path: "/attendance/summary-report",
    name: "Attendance Summary Report",
    meta: {
      title: "Attendance Summary Report",
      authRequired: true,
    },
    component: () => import("../views/attendance/summary-report.vue"),
  },
  //attedance management - summary report
  {
    path: "/attendance/att-stn-summary",
    name: "Attendance Station Summary",
    meta: {
      title: "Attendance Station Summary",
      authRequired: true,
    },
    component: () => import("../views/attendance/att-stn-summary.vue"),
  },
  //location tracking - records
  {
    path: "/administrative/location-track",
    name: "Location Tracking Records",
    meta: {
      title: "Location Tracking Records",
      authRequired: true,
    },
    component: () => import("../views/administrative/location-track.vue"),
  },
  //General Leave - Calendar View
  {
    path: "/general-leave/leave-cal-view",
    name: "General Leave Calendar View",
    meta: {
      title: "General Leave Calendar View",
      authRequired: true,
    },
    component: () => import("../views/general-leave/leave-cal-view.vue"),
  },
  //General Leave - Leave Profile
  {
    path: "/general-leave/profile",
    name: "Employee Leave Profile",
    meta: {
      title: "Employee Leave Profile",
      authRequired: true,
    },
    component: () => import("../views/general-leave/profile.vue"),
  },
  //General Leave - Leave Types (Settings)
  {
    path: "/general-leave/settings-types",
    name: "General Leave Types",
    meta: {
      title: "General Leave Types",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-types.vue"),
  },
  //General Leave - Profile Rules (Settings)
  {
    path: "/general-leave/settings-profile-rules",
    name: "General Leave Profile Rules",
    meta: {
      title: "General Leave Profile Rules",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-profile-rules.vue"),
  },
  //General Leave - Approval Groups (Settings)
  {
    path: "/general-leave/settings-approval-groups",
    name: "General Leave Approval Groups",
    meta: {
      title: "General Leave Approval Groups",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-approval-groups.vue"),
  },
  //General Leave - Approval Routes (Settings)
  {
    path: "/general-leave/settings-approval-routes",
    name: "General Leave Approval Routes",
    meta: {
      title: "General Leave Approval Routes",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-approval-routes.vue"),
  },
  //General Leave - Balances (Settings)
  {
    path: "/general-leave/settings-balances",
    name: "General Leave Balances",
    meta: {
      title: "General Leave Balances",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-balances.vue"),
  },
  //General Leave - Public Holidays (Settings)
  {
    path: "/general-leave/settings-public-holiday",
    name: "Public Holiday Setting",
    meta: {
      title: "Public Holiday Setting",
      authRequired: true,
    },
    component: () => import("../views/general-leave/settings-public-holiday.vue"),
  },
  //General Leave - Viewer (public / shareable; loaded by the mobile WebView)
  {
    path: "/leave/gl-viewer",
    name: "General Leave Viewer",
    meta: {
      title: "General Leave Viewer",
    },
    component: () => import("../views/general-leave/gl-viewer.vue"),
  },
  //site survey - reports
  {
    path: "/site-survey/reports",
    name: "Site Survey Reports",
    meta: {
      title: "Site Survey Reports",
      authRequired: true,
    },
    component: () => import("../views/site-survey/reports.vue"),
  },
  //site survey - report viewer
  {
    path: "/site-survey/report-viewer",
    name: "Site Survey Report Viewer",
    meta: {
      title: "Site Survey Report Viewer"
    },
    component: () => import("../views/site-survey/report-viewer.vue"),
  },
  //toolbox meeting management - reports
  {
    path: "/tm/reports",
    name: "Toolbox Meeting Reports",
    meta: {
      title: "Toolbox Meeting Reports",
      authRequired: true,
    },
    component: () => import("../views/toolbox-meeting/reports.vue"),
  },
  //toolbox meeting management - report viewer
  {
    path: "/tm/report-viewer",
    name: "Toolbox Meeting Report Viewer",
    meta: {
      title: "Toolbox Meeting Report Viewer",
    },
    component: () => import("../views/toolbox-meeting/reportviewer.vue"),
  },

  //public company introduction page
  {
    path: "/about-us",
    name: "About Us",
    meta: {
      title: "About Us",
    },
    component: () => import("../views/pages/about-us.vue"),
  },
  //public privacy policy page (required for Google Play / Apple App Store listings)
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    meta: {
      title: "Privacy Policy",
    },
    component: () => import("../views/pages/privacy-policy.vue"),
  },
  {
    path: "/coming-soon",
    name: "Coming Soon",
    meta: {
      title: "Coming Soon",
      authRequired: true,
    },
    component: () => import("../views/pages/coming-soon.vue"),
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404"
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
];